export default function setLastAccessedOrganization(lastAccessedOrganizationVar) {
    return function (organization) {
        lastAccessedOrganizationVar(organization);
        localStorage.setItem('lastAccessedOrganization', JSON.stringify(organization));
    };
}
